//@flow
export type NotificationAction =
  | {|
      type: 'FETCH_NOTIFICATIONS',
      payload: {|
        refresh: boolean,
        hideErrors: boolean,
      |},
    |}
  | {|
      type: 'FETCH_TRIPICA_NOTIFICATIONS',
      payload: {|
        refresh: boolean,
        hideErrors: boolean,
      |},
    |}
  | {|
      type: 'FETCH_PUSH_NOTIFICATIONS',
      payload: {|
        refresh: boolean,
        hideErrors: boolean,
      |},
    |}
  | {|
      type: 'SET_TRIPICA_NOTIFICATIONS',
      payload: {|
        notifications: Object[],
      |},
    |}
  | {|
      type: 'SET_PUSH_NOTIFICATIONS',
      payload: {|
        notifications: Object[],
      |},
    |};

export const setTriPicaNotifications = (notifications: Object[]) => ({
  type: 'SET_TRIPICA_NOTIFICATIONS',
  payload: { notifications },
});

export const setPushNotifications = (notifications: Object[]) => ({
  type: 'SET_PUSH_NOTIFICATIONS',
  payload: { notifications },
});

export const fetchNotifications = (refresh: boolean = false, hideErrors: boolean = false) => ({
  type: 'FETCH_NOTIFICATIONS',
  payload: { refresh, hideErrors },
});

export const fetchTriPicaNotifications = (refresh: boolean = false, hideErrors: boolean = false) => ({
  type: 'FETCH_TRIPICA_NOTIFICATIONS',
  payload: { refresh, hideErrors },
});

export const fetchPushNotifications = (refresh: boolean = false, hideErrors: boolean = false) => ({
  type: 'FETCH_PUSH_NOTIFICATIONS',
  payload: { refresh, hideErrors },
});
